import * as React from 'react';
import { cn } from '@/lib/utils';
export function Marker({className,children,...props}:React.HTMLAttributes<HTMLDivElement>){return <div data-slot="marker" className={cn('freeui-marker',className)} {...props}><span/>{children}<span/></div>;}
